import GradientFilter from './gradient-filter.component';
export default GradientFilter;
